import { format } from "date-fns";
import { toLocalDate } from "@/utils/dateUtils";

interface EventDateTimeProps {
  status: string;
  eventDate: string | null;
  preferredDates?: string[];
  selectedDate?: string | null;
  preferredTimeOfDay?: string[];
  specificTimePreference?: string | null;
}

export const EventDateTime = ({ 
  status, 
  eventDate, 
  preferredDates, 
  selectedDate,
  preferredTimeOfDay,
  specificTimePreference
}: EventDateTimeProps) => {
  const formatPreferredDates = (dates: string[]) => {
    return dates
      .map(date => {
        try {
          return format(toLocalDate(date), 'dd MMM');
        } catch (error) {
          console.error('Error formatting date:', date, error);
          return date;
        }
      })
      .join(', ');
  };

  const getDateDisplay = () => {
    if ((status === 'confirmed' || status === 'booked') && selectedDate) {
      try {
        const formattedDate = format(new Date(selectedDate), 'EEEE, MMMM d, yyyy');
        return (
          <div className="space-y-1">
            <p className="font-medium">{formattedDate}</p>
            {specificTimePreference && (
              <p className="text-sm text-gray-600">
                {specificTimePreference}
              </p>
            )}
          </div>
        );
      } catch (error) {
        console.error('Error formatting selected date:', selectedDate, error);
      }
    }
    
    if (status === 'planned' && preferredDates && preferredDates.length > 0) {
      return <>{formatPreferredDates(preferredDates)}</>;
    }
    
    return eventDate ? format(new Date(eventDate), 'dd MMM') : 'No date set';
  };

  return (
    <div>{getDateDisplay()}</div>
  );
};
